import React from 'react';
import {FormattedMessage} from 'react-intl';
import Alert from "@amzn/meridian/alert";
import Heading from "@amzn/meridian/heading"
import Column from "@amzn/meridian/column"

export const ExceptionView = ({error}) => {
    return (
        <Alert
            type="error"
            size="xlarge"
        >
            <Column spacing="500">
                <Heading level={2}>
                    <FormattedMessage id={"error" + error.statusCode + ".title"} defaultMessage="Unauthorized Access"></FormattedMessage>
                </Heading>

                <FormattedMessage id={"error" + error.statusCode + ".message"}
                    defaultMessage="Access to critical customer data is blocked with 1FA authentication. 
                Please access this page from an internal network (Over the VPN from a laptop)">
                </FormattedMessage>
            </Column>
        </Alert>
    )
}


// WEBPACK FOOTER //
// ./src/commons/ExceptionView.js